(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DataInput",
                    {
                        url: "/DataInput",
                        component: "mainDataInputComponent",
                        PageTitle: "Data Input | Marketing Tracker",
                        redirectTo: "Home.Tools.MarketingTrackerNew.DataInput.SalesDataInput",
                        resolve: {
                            sources: ["marketingTrackerSalesTrackerSettingsApi", function (marketingTrackerSalesTrackerSettingsApi) {
                                return marketingTrackerSalesTrackerSettingsApi.getSources().then(function (response) { return response; })
                            }],
                            advisors: ["marketingTrackerSalesTrackerSettingsApi", function (marketingTrackerSalesTrackerSettingsApi) {
                                return marketingTrackerSalesTrackerSettingsApi.getAdvisors().then(function (response) { return response; })
                            }],
                            statuses: ["marketingTrackerSalesTrackerSettingsApi", function (marketingTrackerSalesTrackerSettingsApi) {
                                return marketingTrackerSalesTrackerSettingsApi.getStatuses().then(function (response) { return response; })
                            }],
                            linesOfBusiness: ["marketingTrackerSalesTrackerSettingsApi", function (marketingTrackerSalesTrackerSettingsApi) {
                                return marketingTrackerSalesTrackerSettingsApi.getLinesOfBusiness().then(function (response) {
                                    return response.map(function (x) {
                                        return {
                                            name: x.LineOfBusinessName,
                                            id: x.Id,
                                            required: false,
                                        }
                                    });
                                })
                            }],
                            today: [function () {
                                return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                            }],
                            dateSelect: [function () {
                                var today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                                function addMonths(date, months) {
                                    var result = new Date(date.getFullYear(), (date.getMonth() + months), date.getDate());
                                    return result;
                                }
                                return [
                                    {
                                        name: 'Last 6 months',
                                        value: {
                                            startDate: addMonths(today, -6).toISOString(),
                                            endDate: today.toISOString()
                                        }
                                    },
                                    {
                                        name: 'Last 12 months',
                                        value: {
                                            startDate: addMonths(today, -12).toISOString(),
                                            endDate: today.toISOString()
                                        }
                                    },
                                    {
                                        name: 'All time',
                                        value: {
                                            startDate: null,
                                            endDate: null
                                        }
                                    },
                                    {
                                        name: 'Date range',
                                        value: {
                                            startDate: addMonths(today, -6),
                                            endDate: today.toISOString()
                                        }
                                    }
                                ];
                            }],
                            selectedDate: ['dateSelect', function (dateSelect) {
                                return dateSelect[1];
                            }],
                            ngModelOptions: [function () {
                                return {
                                    debounce: 250
                                }
                            }],
                            airDatepickerOptions: [function () {
                                return {
                                    autoClose: true
                                }
                            }],
                        }
                    });
        }
    ]);

    app.component("mainDataInputComponent",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/MainDataInput/main-data-input.template.html",
            controller: mainDataInputController,
            bindings: {
            }
        });

    mainDataInputController.$inject = ["$scope", "$state", "marketingTrackerEventGroupApi", "_", "moment", "$filter"];

    function mainDataInputController($scope, $state, marketingTrackerEventGroupApi, _, moment, $filter) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                nav: [
                    {
                        name: 'Sales',
                        url: '.SalesDataInput'
                    },
                    {
                        name: 'Opportunities',
                        url: '.OpportunitiesDataInput'
                    },
                    {
                        name: 'Spending',
                        url: '.SpendingDataInput'
                    }
                ]
            });

        $ctrl.$onInit = function () {
        };
    }

})(window.app, window.angular); //jshint ignore:line